import { transformToOrganisationOverviewItem } from '../OrganisationOverviewItem/OrganisationOverviewItemTransformers';
import { OrganisationOverview, OrganisationOverviewResource } from './OrganisationOverview';

export const transformToOrganisationOverview = (
    organisationOverviewResource: OrganisationOverviewResource,
): OrganisationOverview => ({
    totalAmount: organisationOverviewResource.meta.totalAmount,
    organisations: organisationOverviewResource.organisations.map(transformToOrganisationOverviewItem),
});
